import { render, staticRenderFns } from "./ImsTemplate.vue?vue&type=template&id=51e34c96&"
import script from "./ImsTemplate.vue?vue&type=script&lang=js&"
export * from "./ImsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports